<template>
  <div>
    <b-modal id="modalEditTunnelAttributesSettings" ref="modalEditTunnelAttributesSettings" :title="$t('Tunnel radius attributes')" hide-footer>
      <div v-if="editItem">
         <b-form-group label-align="right" :label="$t('Vendor ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.vendor_id" aria-describedby="inputFeedbackAttribute" :state="editItem.vendor_id >= 0"/>
          <b-form-invalid-feedback id="inputFeedbackAttribute">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Attribute')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.attr_type" aria-describedby="inputFeedbackAttribute" :state="editItem.attr_type > 0"/>
          <b-form-invalid-feedback id="inputFeedbackAttribute">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Data type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select size="sm" v-model="editItem.data_type" :options="fieldOptions"/>
          <b-form-invalid-feedback id="inputFeedbackVendor">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditTunnelAttributesSettings')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      fieldOptions: [
        {value: 0, text: this.$i18n.t('INT (3 octets)')},
        {value: 1, text: this.$i18n.t('STRING')}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.attr_type) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attribute type is invalid'), 'Error')
        return
      }

      this.editItem.id = Number(this.editItem.id)
      this.editItem.attr_type = Number(this.editItem.attr_type)
      this.editItem.data_type = Number(this.editItem.data_type)
      this.editItem.vendor_id = Number(this.editItem.vendor_id)
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_TUNNEL_ATTRIBUTES', this.editItem)
        : this.$store.dispatch('Settings/CREATE_TUNNEL_ATTRIBUTES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_TUNNEL_ATTRIBUTES')
          this.$refs.modalEditTunnelAttributesSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/TunnelRadiusAttributes/editModal.vue